export const genderData = [
  { _id: 0, title: "Male" },
  { _id: 1, title: "Female" },
];
